import { impacts, impactsList } from '#/modules/alert/utils/constants';

export const typeItems = [
  { key: 'missed_maintenance', label: 'Missed Maintenance' },
  { key: 'deficiency', label: 'Deficiency' },
  { key: 'defect', label: 'Defect' },
  { key: 'issue', label: 'Issue' },
];

// Object format for mappings (used in dashboard cards)
export const types = {
  missed_maintenance: {
    key: 'missed_maintenance',
    label: 'Missed Maintenance',
  },
  deficiency: {
    key: 'deficiency',
    label: 'Deficiency',
  },
  defect: {
    key: 'defect',
    label: 'Defect',
  },
  issue: {
    key: 'issue',
    label: 'Issue',
  },
};

export const statusItems = [
  { key: 'new', label: 'New' },
  { key: 'planned', label: 'Planned' },
  { key: 'in_progress', label: 'In Progress' },
  { key: 'wo_created', label: 'WO Created', disabled: true },
  { key: 'in_review', label: 'In Review', disabled: true },
  { key: 'resolved', label: 'Resolved', disabled: true },
];

export const priorityItems = [
  { key: 2, label: 'Low' },
  { key: 3, label: 'Moderate' },
  { key: 4, label: 'High' },
  { key: 5, label: 'Critical' },
  { key: 1, label: 'Planning' },
];

export enum Priority {
  Planning = 1,
  Low = 2,
  Moderate = 3,
  High = 4,
  Critical = 5,
}
